"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var PayloadAction_1 = require("./PayloadAction");
// default should just not make any changes and return same reference
var defaultReducer = function (state) { return state; };
exports.createReducer = function (initialState) {
    // map of action types -> reducer to run for it
    var mappings = {};
    // reducers that run after every action
    var postReducers = [];
    // actual reducer that will be used by redux
    var reducer = function (state, action) {
        if (state === void 0) { state = initialState; }
        return __spreadArrays([mappings[action.type] || defaultReducer], postReducers).reduce(function (intermediateState, currentReducer) { return currentReducer(intermediateState, action); }, state);
    };
    var helpers = {
        handleUntypedAction: function (action, reducer) {
            if (mappings[action]) {
                throw new Error("Already handling an action with name '" + action + "'");
            }
            mappings[action] = reducer;
            return this;
        },
        handleAction: function (actionCreator, successReducer, failedReducer) {
            var splitReducer = function (state, action) {
                if (PayloadAction_1.isSuccessfulAction(action)) {
                    return successReducer(state, action);
                }
                if (failedReducer) {
                    return failedReducer(state, action);
                }
                return state;
            };
            return this.handleUntypedAction(actionCreator.actionType, splitReducer);
        },
        forProperty: function (prop, reducer) {
            var innerReducer = function (state, action) {
                var _a;
                var input = state[prop];
                var output = reducer(state[prop], action);
                // only return a mutated state if the output has actually changed reference
                return output === input ? state : __assign(__assign({}, state), (_a = {}, _a[prop] = output, _a));
            };
            postReducers.push(innerReducer);
            return this;
        },
    };
    return Object.assign(reducer, helpers);
};
